<h1 ev-dialog-title data-testid="confirm-title">{{ data.title }}</h1>

<div ev-dialog-content class="scrollable" data-testid="confirm-container">
  <div class="confirm-content">
    @if (icon) {
      <img alt="" [src]="icon" class="confirm-icon" />
    }

    @if (message || warning || warning2) {
      <app-modal-option-panel>
        @if (message) {
          <p class="confirm-message" [innerHtml]="message"></p>
        }
        @if (warning) {
          <p class="confirm-warning" [innerHtml]="warning"></p>
        }
        @if (warning2) {
          <p class="confirm-warning" [innerHtml]="warning2"></p>
        }
      </app-modal-option-panel>
    }
  </div>
</div>

<div ev-dialog-actions>
  @if (buttons[0]) {
    <button class="ev-button primary" mat-button data-testid="confirm-accept-btn" (click)="accept()">{{ buttons[0] }}</button>
  }
  @if (buttons[1]) {
    <button class="ev-button" mat-button data-testid="confirm-cancel-btn" (click)="cancel()">{{ buttons[1] }}</button>
  }
</div>
